import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.68 3.12',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M3.51,2.55H.17a.06.06,0,0,1-.06-.06,1.73,1.73,0,0,1,3.46,0A.06.06,0,0,1,3.51,2.55ZM.23,2.43H3.45a1.61,1.61,0,0,0-3.22,0Z"
        />
        <path
          fill={fill}
          d="M3.62,3.12H.06l0,0A.13.13,0,0,1,0,3l.11-.28a.07.07,0,0,1,.06,0H3.51a.07.07,0,0,1,.06,0L3.68,3a.13.13,0,0,1,0,.06ZM.15,3H3.53l-.06-.16H.21Z"
        />
        <path
          fill={fill}
          d="M1.84.61a.3.3,0,0,1-.31-.3.31.31,0,1,1,.62,0A.3.3,0,0,1,1.84.61Zm0-.49a.19.19,0,0,0-.19.19A.19.19,0,0,0,2,.31.19.19,0,0,0,1.84.12Z"
        />
        <path
          fill={fill}
          d="M1.84.88A.06.06,0,0,1,1.78.82V.55a.06.06,0,0,1,.12,0V.82A.06.06,0,0,1,1.84.88Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
